
import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <div className="footer">
      <p>© 2023 - GitScribe</p>
    </div>
  );
}

export default Footer;
